import { getEntityRef } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import appInfo, { isStaffOrSuperUser } from "@common/appInfo";
import { setShowingDetailId, showAddModal } from "./actions";
import Component, { type ActionProps, type MapProps } from "./component";
import { localStateSelector, makeItemsSelector } from "./selectors";
import { type MemberHelpdesk } from "./types";

const makeMapStateToProps = () => {
  const itemsSelector = makeItemsSelector();

  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);
    return {
      ...props,
      canAdd: !isStaffOrSuperUser(),
      tickets: itemsSelector(state, props),
      status: localState.status,
      userId: appInfo.user?.id ?? null
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  onAddClick: () => dispatch(showAddModal(getEntityRef(props))),
  onItemClick: (item: MemberHelpdesk.Ticket) =>
    dispatch(setShowingDetailId({ ...getEntityRef(props), ticketId: item.ticketId }))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
